import { combineReducers } from 'redux';
import customer from 'reducers/customerInfoReducer';
import policy from 'reducers/policyInfoReducer';
import session from 'reducers/sessionReducer';
import edit from 'reducers/editableButtonsReducer';
import content from 'reducers/content';
import documents from 'reducers/documentsReducer';
import step from 'reducers/journeyManagerStepReducer';
import vehicles from 'reducers/vehicleInfoReducer';
import expiryRenewal from 'reducers/expiryRenewalReducer';
import { productsReducer } from 'reducers/productsReducer';
import { loyaltyRewardsReducer } from 'reducers/journeys/loyaltyRewardsReducer';
import { createReduxHistoryContext } from 'redux-first-history';
import { createBrowserHistory } from 'history';
import ldRedux from '@svey/ld-redux';

const { routerReducer } = createReduxHistoryContext({ history: createBrowserHistory() });

const journeysReducer = combineReducers({
  loyaltyRewards: loyaltyRewardsReducer,
});

const appReducer = () => combineReducers({
  router: routerReducer,
  customer,
  policy,
  session,
  edit,
  content,
  documents,
  step,
  vehicles,
  expiryRenewal,
  products: productsReducer,
  featureToggle: ldRedux.reducer(),
  journeys: journeysReducer,
});

export default appReducer;
